import { Dispatch } from "react-redux";
import fp from "lodash/fp";
import { stringify } from "querystring";
import { VARIANTS } from "constants/action-types";
import { IVariantsMap } from "reducers/variants";
import { IStore } from "reducers";
import { IItemRecord } from "records/item/item";

export const fetch = (list: string[]) => (dispatch: Dispatch<{}>, getState: () => IStore) => {
    if (fp.isEmpty(list)) {
        return;
    }
    const store = getState();

    const options = { _id: list, __company: store.scope.viewAs?._id, effectiveDateMs: undefined };
    const catalogScoped = !!window.location?.pathname?.indexOf("/linesheet/");

    const { catalog } = store;
    const effectiveDate =
        catalogScoped && catalog.result.length
            ? catalog.entities.catalogs[catalog.result]?.get("delivery_window_start")
            : null;

    if (effectiveDate) {
        options.effectiveDateMs = effectiveDate;
    }

    dispatch({ type: VARIANTS.FETCH.START, payload: { url: `/api/v3.0/variants?${stringify(options)}` } });
    dispatch({ type: VARIANTS.UPDATE, payload: fp.omit<IVariantsMap>(list, store.variants.payload) }); // clean up the payload not to show invalid swatches
};

export const getVariantsList = fp.compose(
    fp.map("_id"),
    fp.filter((item: IItemRecord) => fp.find({ key: "color" }, item.__variants)?.hasMore),
);
